<template>
    <div class="aromaten">
        <ul>
            <li>C<sub>6</sub>H<sub>6</sub> Benzol</li>
            <li>Phenyl-</li>
            <li>unpolar</li>
            <li>Rußende Flamme bei Verbrennung</li>
            <li>
                Substitutionsreaktion (elektrophile Substitution mit Einsatz
                eines Katalysators möglich)
            </li>
            <li>
                entfärbt Br<sub>2</sub> nur mit Katalysator, Nebenprodukt HBr.
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'aromaten',
};
</script>
